<template>
  <div class="wlx-site-manager-wrapper">
    <div class="u-school-manager-head stu-manager-head-con clearfix">
      <router-link :to="{name:'adoptSchool'}" class="head-link-a">站点管理</router-link>
      <router-link :to="{name:'assessmentApply'}" class="head-link-a">考核站点申请</router-link>
       <router-link :to="{name:'provincialHead'}" class="head-link-a">省级工作室</router-link>
       <!-- <router-link :to="{name:'statistical'}" class="head-link-a">毕业生就业信息统计</router-link> -->
    </div>
    <div class="u-table-main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  .stu-manager-head-con {
    text-align: left;
    background: #fff;
    .head-link-a {
      float: left;
      padding: 0 20px;
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #000;
    }
    .head-link-a:hover {
      color: #409eff;
    }
    .linkActive {
      border-bottom: 2px solid #409eff;
      color: #409eff;
    }
  }
}
</style>